import { deserialize } from 'cerialize'
import { ShortDataModel } from 'Models'
import { getDate, getTime } from 'Helpers'

export class PartnerSettingModel {
	@deserialize public id: number
	@deserialize public created_at?: string
	@deserialize public calls_per_hour: number
	@deserialize public calls_per_minute: number
	@deserialize public is_active: boolean
	@deserialize public uuid: string
	@deserialize public partner_id: number
	@deserialize public user_ids: number[]
	@deserialize public partner: ShortDataModel
	@deserialize public users: ShortDataModel[]

	public get data_create(): string | undefined {
		return `${getDate(this.created_at)} ${getTime(this.created_at)}`
	}
}
